import React, { useEffect } from 'react'
import { PrimeReactProvider } from "primereact/api"
import "primereact/resources/themes/lara-light-cyan/theme.css"
import { Router } from './routes/Router'
import { getSessionItem, setSessionItem } from './utils/helper/session'
import { stopWebTrackerRequest, updateLogTrackerStatusRequest } from './services/trackerServices/trackerService'
import { useNavigate } from 'react-router-dom'
import { setNavigate } from './utils/helper/navigationHelper'
import { OnboardingProvider } from './context/onboardingContext'
import { ConfirmDialog } from 'primereact/confirmdialog';
import { PermissionProvider } from './security'

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate()
    
  }, [navigate])

  useEffect(() => {
    const tracker = getSessionItem("Tracker")
    if (!tracker) {
      setSessionItem("Tracker", {
        online: false,
        projectId: 0,
        project: 'default',
        weeklyTime: 0,
        dailyTime: 0
      })
    }
  }, [])

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const tracker = getSessionItem("Tracker")
      const user = getSessionItem("User")
      const sessionId = getSessionItem("session")

      if (!tracker?.online || !user?.username || !sessionId) return

      navigator.sendBeacon(
        updateLogTrackerStatusRequest,
        JSON.stringify({
          ID: sessionId,
          Online: false
        })
      )

      navigator.sendBeacon(
        stopWebTrackerRequest,
        JSON.stringify({ username: user.username })
      )

      event.preventDefault()
      event.returnValue = ''
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [])

  return (
    <PrimeReactProvider>
      <OnboardingProvider>
        <PermissionProvider>
          <ConfirmDialog />
          <Router />
        </PermissionProvider>
      </OnboardingProvider>
    </PrimeReactProvider>
  )
}

export default App
